import { render, staticRenderFns } from "./b-modal.vue?vue&type=template&id=69addee6&scoped=true"
import script from "./b-modal.vue?vue&type=script&lang=js"
export * from "./b-modal.vue?vue&type=script&lang=js"
import style0 from "./b-modal.vue?vue&type=style&index=0&id=69addee6&prod&lang=scss&scoped=true"
import style1 from "./b-modal.vue?vue&type=style&index=1&id=69addee6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69addee6",
  null
  
)

export default component.exports